<div class="ai-image-edit-wrapper">
  <!-- 이미지 클릭 영역 -->
  <div class="image-container" (click)="openLightbox()">
    <ng-content></ng-content>
  </div>

  <!-- 편집 버튼 -->
  <button class="edit-btn"
          aria-label="이미지 편집 옵션 열기"
          *ngIf="!showOverlay && !isEnhancing && showEditButton"
          (click)="toggleOverlay(); $event.stopPropagation()"
          [disabled]="disabled">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
    </svg>
    편집
  </button>

  <!-- 편집 오버레이 -->
  <div class="overlay" *ngIf="showOverlay" @fadeInOut (click)="$event.stopPropagation()">
    <div class="overlay__header">
      <button class="close-btn" aria-label="편집 옵션 닫기" (click)="toggleOverlay()">✕</button>
      <button class="undo-btn" aria-label="이전 이미지로 되돌리기" [disabled]="!canUndo" (click)="undo()">되돌리기</button>
    </div>
    <div class="buttons">
      <button class="action-btn" (click)="enhance('quality')">✨ 품질개선</button>
      <button class="action-btn" (click)="enhance('regenerate')">🔄 재생성</button>
      <button class="action-btn" (click)="enhance('add_people')">👥 사람추가</button>
      <button class="action-btn" (click)="enhance('clear_weather')">☀️ 날씨맑음</button>
      <button class="action-btn" (click)="togglePromptInput()">💬 프롬프트</button>
    </div>
    <div class="prompt-container" *ngIf="showPromptInput">
      <textarea class="prompt-input"
                [(ngModel)]="customPrompt"
                placeholder="원하는 편집 내용을 입력하세요..."
                (keydown.enter)="onPromptEnter($event)"></textarea>
      <div class="prompt-hint">Enter로 실행</div>
    </div>
    <div class="error-container" *ngIf="error">
      <span class="error-message">{{ error }}</span>
      <button class="error-dismiss-btn" (click)="dismissError()">X</button>
    </div>
  </div>

  <!-- 로딩 오버레이 -->
  <div class="loading-overlay" *ngIf="isEnhancing">
    <div class="spinner"></div>
    <span class="loading-text">AI 편집 중...</span>
  </div>
</div>

<!-- 라이트박스는 body에 직접 추가됨 (createLightboxElement) -->
